export const env = "production";

export const firebase = {
  apiKey: "AIzaSyCzD92ZayixHoXIsHAUdg3mlomV1vj3NAk",
  authDomain: "prepper-pro.firebaseapp.com",
  databaseURL: "https://prepper-pro.firebaseio.com",
  projectId: "prepper-pro",
  storageBucket: "prepper-pro.appspot.com",
  messagingSenderId: "377535370969",
  appId: "1:377535370969:web:b247249a74f38da8",
  measurementId: "G-ENKJ2BQH8H",
};

export const githubBuildNumber = "66";

export const gitCommit = "2bf76b2d5fd37d794bf72530e65044092ac5f7e7";

export const lang = "de";

export default { env, firebase, githubBuildNumber, gitCommit, lang };
